import { render, staticRenderFns } from "./IconRightwardsArrowWithTail.vue?vue&type=template&id=4e0d9f14&"
import script from "./IconRightwardsArrowWithTail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IconRightwardsArrowWithTail.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports